import { useEffect, useRef, useState } from 'react';
import { Dialog } from './Formular.tsx';
import {
  ZURUECK, alsProzent, alsUmformung, doppeltipp, istGezoomt, schieben, zoomAn, zoomRad, type Zoomstand,
} from './zoomen.ts';

/* EIN BILD GROSS, IN EINEM KLEINEN FENSTER (.251).
 * ============================================================================
 * ORIGINALTEXT MARVIN (28.09.2026, zum Artikelbild)
 *   „das bild soll noch anklickbar und zoombar sein, einfach als kleiner
 *    popup fenster"
 *
 * Kein Vollbild: ein Fenster über dem Artikel, das man schließt und wieder
 * beim Artikel ist. Die Rechnung (Mausrad um den Zeiger, Klick schaltet um,
 * Ziehen verschiebt, nie über die Kante) steht in `zoomen.ts` und wird hier
 * nur benutzt. Mehrere Bilder: Pfeile oder Pfeiltasten. */

export default function Bildzoom({ titel, adressen, start = 0, zu }: {
  titel: string; adressen: string[]; start?: number; zu: () => void;
}) {
  const [i, setI] = useState(start);
  const [s, setS] = useState<Zoomstand>({ ...ZURUECK });
  const kasten = useRef<HTMLDivElement | null>(null);
  const zug = useRef<{ x: number; y: number; bewegt: boolean } | null>(null);
  const k = () => {
    const r = kasten.current?.getBoundingClientRect();
    return { breite: r?.width ?? 1, hoehe: r?.height ?? 1 };
  };
  const punkt = (e: { clientX: number; clientY: number }) => {
    const r = kasten.current!.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };

  // Das Rad von Hand und nicht passiv: sonst rollt die Seite dahinter mit.
  useEffect(() => {
    const el = kasten.current;
    if (!el) return;
    const rad = (e: WheelEvent) => { e.preventDefault(); setS((alt) => zoomRad(alt, e.deltaY, punkt(e), k())); };
    el.addEventListener('wheel', rad, { passive: false });
    return () => el.removeEventListener('wheel', rad);
  }, []);

  useEffect(() => {
    const taste = (e: KeyboardEvent) => {
      if (adressen.length < 2) return;
      if (e.key === 'ArrowRight') { setI((x) => (x + 1) % adressen.length); setS({ ...ZURUECK }); }
      if (e.key === 'ArrowLeft') { setI((x) => (x - 1 + adressen.length) % adressen.length); setS({ ...ZURUECK }); }
    };
    window.addEventListener('keydown', taste);
    return () => window.removeEventListener('keydown', taste);
  }, [adressen.length]);

  const blaettern = (d: number) => { setI((x) => (x + d + adressen.length) % adressen.length); setS({ ...ZURUECK }); };

  return (
    <Dialog titel={titel} untertitel={adressen.length > 1 ? `Bild ${i + 1} von ${adressen.length}` : undefined}
            breite={720} zu={zu}>
      <div ref={kasten} className={istGezoomt(s) ? 'bildzoom gezoomt' : 'bildzoom'}
           onPointerDown={(e) => { (e.target as Element).setPointerCapture?.(e.pointerId); zug.current = { x: e.clientX, y: e.clientY, bewegt: false }; }}
           onPointerMove={(e) => {
             const z = zug.current;
             if (!z) return;
             const dx = e.clientX - z.x, dy = e.clientY - z.y;
             if (Math.abs(dx) + Math.abs(dy) > 3) z.bewegt = true;
             if (z.bewegt && istGezoomt(s)) { setS((alt) => schieben(alt, dx, dy, k())); z.x = e.clientX; z.y = e.clientY; }
           }}
           onPointerUp={(e) => {
             const z = zug.current;
             zug.current = null;
             if (z && !z.bewegt) setS((alt) => doppeltipp(alt, punkt(e), k()));
           }}>
        <img src={adressen[i]} alt="" draggable={false} style={{ transform: alsUmformung(s) }} />
      </div>
      <div className="reihe bildzoomleiste">
        {adressen.length > 1 && <button type="button" className="knopf klein" onClick={() => blaettern(-1)}>‹ voriges</button>}
        <button type="button" className="knopf klein" onClick={() => setS((alt) => zoomAn(alt, alt.faktor / 1.4, { x: k().breite / 2, y: k().hoehe / 2 }, k()))}>−</button>
        <span className="klein leise">{alsProzent(s)}</span>
        <button type="button" className="knopf klein" onClick={() => setS((alt) => zoomAn(alt, alt.faktor * 1.4, { x: k().breite / 2, y: k().hoehe / 2 }, k()))}>+</button>
        {istGezoomt(s) && <button type="button" className="knopf klein" onClick={() => setS({ ...ZURUECK })}>ganz</button>}
        {adressen.length > 1 && <button type="button" className="knopf klein" onClick={() => blaettern(1)}>nächstes ›</button>}
        <span className="klein leise" style={{ marginLeft: 'auto' }}>Mausrad oder Klick vergrößert, ziehen verschiebt.</span>
      </div>
    </Dialog>
  );
}
